var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-nav c-nav--floating-footer-sticky-pending-payment padding-payment-footer"},[_c('ButtonDefinitive',{attrs:{"label":"Ver recibo"},on:{"click":_vm.sendToPayU}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }